import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { bindPropStore } from "../bindProps";
import { objects, text } from "../helpers";
import { getPhosphorIcon } from "../../app/icons.js";

var root = $.from_html(`<div class="slex-doc-detail-rail-title"> </div>`);
var root_1 = $.from_html(`<a> </a>`);
var root_2 = $.from_html(`<nav class="slex-doc-detail-toc"><!> <!></nav>`);
var root_3 = $.from_html(`<span class="slex-doc-detail-copy-action"><button type="button" class="slex-doc-detail-action"><span class="slex-doc-detail-action-icon" aria-hidden="true"></span> </button> <span class="slex-doc-detail-copy-feedback" aria-live="polite"> </span></span>`);
var root_4 = $.from_html(`<a class="slex-doc-detail-action" target="_blank" rel="noreferrer"><span class="slex-doc-detail-action-icon" aria-hidden="true"></span> </a>`);
var root_5 = $.from_html(`<div class="slex-doc-detail-actions slex-doc-detail-actions--rail"><!> <!> <!></div>`);
var root_6 = $.from_html(`<aside><!> <!></aside>`);

export default function DocRail($$anchor, $$props) {
	$.push($$props, true);

	let p = $.state($.proxy({}));

	$.user_effect(() => bindPropStore($$props.props, (next) => $.set(p, next, true)));

	function tocItems() {
		const maxDepth = Number($.get(p).maxDepth ?? 2);

		return objects($.get(p).items ?? $.get(p).toc).filter((item) => Number(item.depth ?? 2) <= maxDepth);
	}

	function itemHref(item) {
		const href = text(item.href);

		if (href) return href;

		const id = text(item.id);

		return id ? `#${id}` : "#";
	}

	function itemLabel(item) {
		return text(item.label ?? item.title ?? item.id).replace(/^\s*\d+[.\u3001]\s*/, "");
	}

	function itemDepth(item) {
		return text(item.depth ?? 2);
	}

	function isActive(item) {
		const active = text($.get(p).active);

		if (!active) return false;

		const href = itemHref(item);

		return active === href || active.replace(/^#/, "") === href.replace(/^#/, "");
	}

	function canCopy() {
		return typeof $.get(p).onCopy === "function";
	}

	function copyPage() {
		if (typeof $.get(p).onCopy === "function") $.get(p).onCopy();
	}

	function hasActions() {
		return canCopy() || Boolean(text($.get(p).markdownHref)) || Boolean(text($.get(p).playgroundHref ?? $.get(p).liveHref));
	}

	var aside = root_6();
	var node = $.child(aside);

	{
		var consequent_1 = ($$anchor) => {
			var nav = root_2();
			var node_1 = $.child(nav);

			{
				var consequent = ($$anchor) => {
					var div = root();
					var text_1 = $.child(div, true);

					$.reset(div);
					$.template_effect(($0) => $.set_text(text_1, $0), [() => text($.get(p).label, "本页")]);
					$.append($$anchor, div);
				};

				$.if(node_1, ($$render) => {
					if ($.get(p).label !== false) $$render(consequent);
				});
			}

			var node_2 = $.sibling(node_1, 2);

			$.each(node_2, 17, tocItems, $.index, ($$anchor, item) => {
				var a = root_1();
				let classes;
				var text_2 = $.child(a, true);

				$.reset(a);

				$.template_effect(
					($0, $1, $2, $3, $4) => {
						classes = $.set_class(a, 1, $0, null, classes, $1);
						$.set_attribute(a, 'href', $2);
						$.set_attribute(a, 'aria-current', $3);
						$.set_text(text_2, $4);
					},
					[
						() => `slex-doc-detail-toc-link slex-doc-detail-toc-link--depth-${itemDepth($.get(item))}`,
						() => ({ 'slex-doc-detail-toc-link--active': isActive($.get(item)) }),
						() => itemHref($.get(item)),
						() => isActive($.get(item)) ? "true" : undefined,
						() => itemLabel($.get(item))
					]
				);

				$.append($$anchor, a);
			});

			$.reset(nav);
			$.template_effect(($0) => $.set_attribute(nav, 'aria-label', $0), [() => text($.get(p).ariaLabel, "本页目录")]);
			$.append($$anchor, nav);
		};

		var d = $.derived(() => tocItems().length);

		$.if(node, ($$render) => {
			if ($.get(d)) $$render(consequent_1);
		});
	}

	var node_3 = $.sibling(node, 2);

	{
		var consequent_5 = ($$anchor) => {
			var div_1 = root_5();
			var node_4 = $.child(div_1);

			{
				var consequent_2 = ($$anchor) => {
					var span = root_3();
					var button = $.child(span);
					var span_1 = $.child(button);

					$.html(span_1, () => getPhosphorIcon("copy"), true);
					$.reset(span_1);

					var text_3 = $.sibling(span_1, 1, true);

					$.reset(button);

					var span_2 = $.sibling(button, 2);
					var text_4 = $.child(span_2, true);

					$.reset(span_2);
					$.reset(span);

					$.template_effect(
						($0, $1, $2, $3) => {
							$.set_attribute(button, 'title', $0);
							$.set_text(text_3, $1);
							$.set_attribute(span_2, 'data-state', $2);
							$.set_text(text_4, $3);
						},
						[
							() => text($.get(p).copyLabel, "复制页面"),
							() => text($.get(p).copyLabel, "复制页面"),
							() => text($.get(p).copyFeedbackState, "success"),
							() => text($.get(p).copyFeedback)
						]
					);

					$.delegated('click', button, copyPage);
					$.append($$anchor, span);
				};

				var d_1 = $.derived(() => canCopy());

				$.if(node_4, ($$render) => {
					if ($.get(d_1)) $$render(consequent_2);
				});
			}

			var node_5 = $.sibling(node_4, 2);

			{
				var consequent_3 = ($$anchor) => {
					var a_1 = root_4();
					var span_3 = $.child(a_1);

					$.html(span_3, () => getPhosphorIcon("markdown-logo"), true);
					$.reset(span_3);

					var text_5 = $.sibling(span_3, 1, true);

					$.reset(a_1);

					$.template_effect(
						($0, $1, $2) => {
							$.set_attribute(a_1, 'title', $0);
							$.set_attribute(a_1, 'href', $1);
							$.set_text(text_5, $2);
						},
						[
							() => text($.get(p).viewMarkdownLabel, "查看 Markdown"),
							() => text($.get(p).markdownHref),
							() => text($.get(p).markdownLabel, "Markdown")
						]
					);

					$.append($$anchor, a_1);
				};

				var d_2 = $.derived(() => text($.get(p).markdownHref));

				$.if(node_5, ($$render) => {
					if ($.get(d_2)) $$render(consequent_3);
				});
			}

			var node_6 = $.sibling(node_5, 2);

			{
				var consequent_4 = ($$anchor) => {
					var a_2 = root_4();
					var span_4 = $.child(a_2);

					$.html(span_4, () => getPhosphorIcon("square-split-horizontal"), true);
					$.reset(span_4);

					var text_6 = $.sibling(span_4, 1, true);

					$.reset(a_2);

					$.template_effect(
						($0, $1, $2) => {
							$.set_attribute(a_2, 'title', $0);
							$.set_attribute(a_2, 'href', $1);
							$.set_text(text_6, $2);
						},
						[
							() => text($.get(p).openLiveLabel, "以 Live 模式打开"),
							() => text($.get(p).playgroundHref ?? $.get(p).liveHref),
							() => text($.get(p).openLiveLabel, "以 Live 模式打开")
						]
					);

					$.append($$anchor, a_2);
				};

				var d_3 = $.derived(() => text($.get(p).playgroundHref ?? $.get(p).liveHref));

				$.if(node_6, ($$render) => {
					if ($.get(d_3)) $$render(consequent_4);
				});
			}

			$.reset(div_1);
			$.template_effect(($0) => $.set_attribute(div_1, 'aria-label', $0), [() => text($.get(p).actionsLabel, "文档")]);
			$.append($$anchor, div_1);
		};

		var d_4 = $.derived(() => hasActions());

		$.if(node_3, ($$render) => {
			if ($.get(d_4)) $$render(consequent_5);
		});
	}

	$.reset(aside);

	$.template_effect(($0) => $.set_class(aside, 1, $0), [
		() => `slex-doc-detail-rail${$.get(p).class ? ` ${text($.get(p).class)}` : ""}`
	]);

	$.append($$anchor, aside);
	$.pop();
}

$.delegate(['click']);